export default { required: true, regexp: '^.+@.+\\.[a-zA-Z]{2,4}$', regexpErrorMsg: 'Некорректный email' };
